import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../shared/ui/controls/Button/Button";
import { timeEntryCategoryOptions } from "../../../../entities/time-entry";
import { routes } from "../../../../shared/config/routes";

export const CategoryActionMenu: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    const onMouseDown = (e: MouseEvent) => {
      if (!containerRef.current?.contains(e.target as Node)) close();
    };
    document.addEventListener("mousedown", onMouseDown);
    return () => document.removeEventListener("mousedown", onMouseDown);
  }, [close]);

  return (
    <div className="relative" ref={containerRef}>
      <Button
        variant="surface"
        className="w-[260px]"
        onClick={() => setOpen((prev) => !prev)}
      >
        Abwesenheit planen
      </Button>

      {open && (
        <div className="absolute right-0 top-full z-50 mt-1 w-[260px] rounded-lg bg-white shadow-lg">
          {timeEntryCategoryOptions.map((option) => (
            <button
              key={option.value}
              className="w-full px-4 py-3 text-left font-['PT_Sans'] text-[16px] text-[#333] hover:bg-[#F5F5F5] first:rounded-t-lg last:rounded-b-lg"
              onClick={() => {
                close();
                navigate(
                  `${routes.zeitmanagement.create}?category=${option.value}`,
                );
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
